import { snakeToCamel } from "@/helpers";
import {
  INDEX,
  INDEX_WITH_PROFILE_ID,
  TAXONOMY_INDEX,
  SORTED_TAXONOMY_INDEX,
  CREATE,
  SHOW,
  SHOW_WITH_PROFILE_ID,
  DELETE,
  EDIT,
  UPLOAD_IMAGE
} from "@/utils/api-url";
import apiDispatcher from "@/utils/api-dispatcher";
import camelCase from "lodash/camelCase";

const USER_PERMISSION_TO_USER_TYPE = {
  collegeHeadCoach: "coach/getone",
  player: "athlete/getone",
  clubHeadCoach: "clubcoach/getClubHeadCoach",
  premiumclubHeadCoach: "clubcoach/getClubHeadCoach",
  collegeNormalCoach: "coach/getone",
  collegeProfileMaintainer: "coach/getone"
};

const USER_PERMISSION_TO_UNIQUE_SLUG = {
  collegeHeadCoach: "collegeCoach",
  player: "athlete",
  clubHeadCoach: "clubCoach",
  premiumclubHeadCoach: "clubCoach",
  collegeNormalCoach: "collegeCoach",
  collegeProfileMaintainer: "collegeCoach"
};

const HUMANIZED_ROLE_MAPPER = {
  collegeHeadCoach: "College Head Coach",
  player: "Athlete",
  clubHeadCoach: "Club Head Coach",
  premiumclubHeadCoach: "Premium Club Head Coach",
  collegeNormalCoach: "College Coach",
  collegeProfileMaintainer: "College Profile Maintainer"
};

export default class Base {
  constructor(params = {}) {
    const serializedData = snakeToCamel(params);
    for (const key in serializedData) {
      this[key] = serializedData[key];
    }
  }

  static userTypeUrl() {
    if (localStorage["user-permissions"])
      return USER_PERMISSION_TO_USER_TYPE[
        JSON.parse(localStorage["user-permissions"])
      ];
    return "";
  }

  static userType() {
    if (localStorage["user-permissions"])
      return USER_PERMISSION_TO_UNIQUE_SLUG[
        JSON.parse(localStorage["user-permissions"])
      ];
  }

  static userImage() {
    if (localStorage["user-permissions"]) return localStorage["user-image"];
    return "";
  }

  static isLoggedIn() {
    return Boolean(localStorage["token"]);
  }

  static userId() {
    if (localStorage["user-id"]) return JSON.parse(localStorage["user-id"]);
    return "";
  }

  static profileId() {
    return (
      window.location.pathname.split("/")[1] || localStorage["profile-id"] || ""
    );
  }

  static userName() {
    if (localStorage["user-name"]) return JSON.parse(localStorage["user-name"]);
    return "";
  }

  static humanizedRole(role) {
    return HUMANIZED_ROLE_MAPPER(role);
  }

  static userRole() {
    if (localStorage["user-permissions"])
      return JSON.parse(localStorage["user-permissions"]);
    return "";
  }

  static index(params) {
    let resourceName = this.resourceName();
    resourceName = camelCase(resourceName);
    return apiDispatcher(INDEX(params, resourceName));
  }

  static show(params) {
    let resourceName = this.resourceName();
    resourceName = camelCase(resourceName);
    return apiDispatcher(SHOW(params, resourceName));
  }

  static showWithProfileId(params) {
    let resourceName = this.resourceName();
    resourceName = camelCase(resourceName);
    const profileId = this.profileId();

    return apiDispatcher(SHOW_WITH_PROFILE_ID(params, resourceName, profileId));
  }

  static indexWithProfileId(params) {
    let resourceName = this.resourceName();
    resourceName = camelCase(resourceName);
    const profileId = this.profileId();
    return apiDispatcher(
      INDEX_WITH_PROFILE_ID(params, resourceName, profileId)
    );
  }

  static getTaxonomyItems(params) {
    return apiDispatcher(TAXONOMY_INDEX(params.type));
  }

  static getSortedTaxonomyItems(params) {
    return apiDispatcher(SORTED_TAXONOMY_INDEX(params.type));
  }

  static create(data) {
    let resourceName = this.resourceName();
    return apiDispatcher(CREATE(data, resourceName));
  }

  static delete(params) {
    return apiDispatcher(DELETE(this.resourceName(), params));
  }

  static edit(params) {
    return apiDispatcher(
      EDIT(this.resourceName(), params.id, { ...params, id: null })
    );
  }

  static uploadImage(params) {
    const id = params["id"];
    return apiDispatcher(
      UPLOAD_IMAGE(this.resourceName(), id, params["image"])
    );
  }

  static nYears = number => {
    const currentYear = new Date().getFullYear();
    let years = [];
    for (let i = currentYear; i < currentYear + number + 1; i++) {
      years.push({ label: i.toString(), value: i });
    }
    return years;
  };

  static nPastYears = number => {
    const currentYear = new Date().getFullYear();
    let years = [];
    for (let i = currentYear; i > currentYear - (number + 1); i--) {
      years.push({ label: i.toString(), value: i });
    }
    return years;
  };
}
